export const GET_DETAIL_THUCHI = "GET_DETAIL_THUCHI";
export const GET_DETAIL_THUCHI_SUCCESS = "GET_DETAIL_THUCHI_SUCCESS";
export const GET_DETAIL_THUCHI_FAILURE = "GET_DETAIL_THUCHI_FAILURE";

export const POST_THANHTOAN = "POST_THANHTOAN";
export const POST_THANHTOAN_SUCCESS = "POST_THANHTOAN_SUCCESS";
export const POST_THANHTOAN_FAILURE = "POST_THANHTOAN_FAILURE";

export const DELETE_THANHTOAN = "DELETE_THANHTOAN";
export const DELETE_THANHTOAN_SUCCESS = "DELETE_THANHTOAN_SUCCESS";
export const DELETE_THANHTOAN_FAILURE = "DELETE_THANHTOAN_FAILURE";
export const UPDATE_OBJ_THANHTOAN = "UPDATE_OBJ_THANHTOAN";
export const UPDATE_OBJVALUE_THANHTOAN = "UPDATE_OBJVALUE_THANHTOAN";
export const POST_THANHTOAN_ALL = "POST_THANHTOAN_ALL";
